import {
  isTagIdResponseDTO,
  TagIdResponseApi,
} from "../DTO/ServerResponseType/Tag/TagId";
import { ServerClient, serverOrigin } from "./Configs";
import { getTypeGuardedVariableAsync } from "./typeGuard";

class TagServerClient {
  private path = "/tag";

  sendToCreateTagAsync = async (tagName: string): Promise<string | never> => {
    return await getTypeGuardedVariableAsync(
      this.sendNewTagAsync(tagName),
      isTagIdResponseDTO
    ).then((tagIdDTO: TagIdResponseApi) => {
      alert("Тег успешно создана.");
      return tagIdDTO.tagId;
    });
  };

  sendNewTagAsync = async (tagName: string): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ tagName: tagName }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToDeleteTagAsync = async (deletedTagId: string): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ tagId: deletedTagId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };
}

let tagServerClient = new TagServerClient();

export default tagServerClient;
